import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";

import { useParams, useNavigate, useLocation } from "react-router-dom";
// import toast, { ToastContainer } from 'react-toastify'; // Importing the default export
// import 'react-toastify/dist/ReactToastify.css'; // Importing CSS separately if needed


const API_URL = process.env.REACT_APP_THEME_API_URL;

/**
 * ReConfirmDeleteAccount component asks the user to confirm deletion of a PAN account.
 * Handles deletion logic, loading state, and navigation.
 */
const ReConfirmDeleteAccount = ({ login = null }) => {
  const { userId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const userData = location.state?.userData || {};
  const [loading, setLoading] = useState(false);
  const handleYesClick = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/pan-detail-delete/${userId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        // Remove the item or take any other action on successful deletion
        // alert("Account deleted successfully");
        navigate(-1);
      } else {
        // Handle error response
        const errorData = await response.json();
        alert("Failed to delete account. Please try again later.");
        console.error("Failed to delete detail:", errorData);
      }
    } catch (error) {
      // Handle network error or other exceptions
      console.error("Error while deleting detail:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container mt-4">
        <div className="row align-items-center">
          <div className="col-md-6 col-12 mt-5 pancard-data">
            <div className="text-center mb-7">
              <img
                width="300"
                alt="icon"
                src={toAbsoluteUrl("/media/images/reconfirmation-min.png")}
              />
            </div>
          </div>

          <div className="col-md-6 col-12">
            <h1 className="mb-5">Re-Confirm</h1>
            <p className="grey-text">
              Are You Sure ? <br></br>that you want to delete this Account
            </p>
            <div className="verify_upi">
              <div className="details_card">
                <label className="grey-text">Pan Card Number</label>
                <p>{userData.api_pan}</p>
              </div>

              <div className="details_card">
                <label className="grey-text">Registered Name</label>
                <p>{userData.api_registered_name}</p>
              </div>
            </div>

            <div className="btns cn-btn mt-15 d-flex">
              <button
                className="btn bgdark-blue text-white"
                onClick={() => navigate(-1)}
              // disabled={loading}
              >
                {/* {loading ? "Loading..." : "No"} */}No
              </button>

              <button
                className="btn red-btn text-white"
                onClick={handleYesClick}
                disabled={loading}
              >
                {loading ? "Loading..." : "Yes"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReConfirmDeleteAccount;
